//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'SquareImage',
  props: {
    src: {
      type: String,
      required: true
    },
    srcset: {
      type: String,
      default: null
    },
    alt: {
      type: String,
      default: ''
    }
  }
};